<p class="header">{{ title }}</p>
<div class="content">
    <p>{{ content }}</p>    

    <div class="buttons-box">
        <a mat-dialog-close>No estoy seguro</a>
        <a class="button-primary" routerLink="./app" mat-dialog-close>Si, estoy seguro</a>
    </div>    
</div>